export default __webpack_public_path__ + "images/logoSkinAuthority.07706745fff71a036fd03b999f0b1d7b.svg"